/**
 * Win/Lose result panel — DOM port of amgcommon_v2 `GameResultPanel`
 * (used by bandarqq_v2's game_screen.dart:765-777 — bandarqq does NOT
 * drive a Rive win/lose artboard; the panel is Flutter-side overlay).
 *
 * Auto-hides after 3 s, optionally triggers an onHide callback.
 */
function fmtCurrency(n: number): string {
  return Math.round(n).toLocaleString('en-US');
}

export class ResultPanel {
  private readonly el: HTMLElement;
  private readonly titleEl: HTMLElement;
  private readonly amountEl: HTMLElement;
  private hideTimer: number | null = null;
  private _onHide: (() => void) | null = null;

  constructor() {
    const host = document.getElementById('dom-hud');
    if (!host) throw new Error('ResultPanel: #dom-hud missing');

    this.el = document.createElement('div');
    this.el.className = 'result-panel';

    this.titleEl = document.createElement('div');
    this.titleEl.className = 'result-title';
    this.titleEl.textContent = 'YOU WIN';

    this.amountEl = document.createElement('div');
    this.amountEl.className = 'result-amount';
    this.amountEl.textContent = '0';

    this.el.append(this.titleEl, this.amountEl);
    host.appendChild(this.el);
  }

  show(isWin: boolean, amount: number, autoHideMs = 3000): void {
    this.titleEl.textContent = isWin ? 'YOU WIN' : 'YOU LOSE';
    this.amountEl.textContent = fmtCurrency(amount);
    this.el.classList.toggle('win', isWin);
    this.el.classList.toggle('lose', !isWin);
    this.el.classList.add('visible');

    if (this.hideTimer != null) window.clearTimeout(this.hideTimer);
    if (autoHideMs > 0) {
      this.hideTimer = window.setTimeout(() => this.hide(), autoHideMs);
    }
  }

  hide(): void {
    if (this.hideTimer != null) {
      window.clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
    this.el.classList.remove('visible');
    this._onHide?.();
  }

  onHide(cb: () => void): void {
    this._onHide = cb;
  }
}
